import 'whatwg-fetch';
import 'idempotent-babel-polyfill';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import queryString from 'query-string';

var listSearchLoads = [];

var path = '';

async function searchApi(data) {
  path = ProductFinder.options.settings.alternativeSearchUrl;

  let query = {};
  if (data.key < 3) {
    return null;
  }
  let queryPath = path + data.key;
  // Get the current filters.
  query['with_results'] = !!data.withResults;
  if (data.page > 0) {
    query['page'] = data.page;
  }
  queryPath = queryPath + '?' + queryString.stringify(query, { arrayFormat: 'bracket' });

  listSearchLoads.forEach((control) => {
    control.abort();
  })
  listSearchLoads = [];
  const controller = new AbortController();
  listSearchLoads.push(controller);
  const signal = controller.signal;
  try {
    const response = await window.fetch(queryPath, { signal: signal });
    return await response.json();
  } catch (e) {
    return null;
  }
}

export default searchApi;
